import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class JwtStorageService {
  TOKEN_NAME = 'buyer_access_token';
  REFRESH_TOKEN_NAME = 'buyer_refresh_token';

  tokenName: string;
  refreshTokenName: string;

  constructor() {
    switch (environment.env) {
      case 'dev':
        this.tokenName = 'dev-' + this.TOKEN_NAME;
        this.refreshTokenName = 'dev-' + this.REFRESH_TOKEN_NAME;
        break;
      case 'stage':
        this.tokenName = 'stage-' + this.TOKEN_NAME;
        this.refreshTokenName = 'stage-' + this.REFRESH_TOKEN_NAME;
        break;
      case 'production':
        this.tokenName = this.TOKEN_NAME;
        this.refreshTokenName = this.REFRESH_TOKEN_NAME;
        break;
    }
  }

  getToken(): string {
    return localStorage.getItem(this.tokenName);
  }

  setToken(token: string): void {
    localStorage.setItem(this.tokenName, token);
  }

  removeToken(): void {
    localStorage.removeItem(this.tokenName);
  }

  getRefreshToken(): string {
    return localStorage.getItem(this.refreshTokenName);
  }

  setRefreshToken(refreshToken: string): void {
    localStorage.setItem(this.refreshTokenName, refreshToken);
  }

  removeRefreshToken(): void {
    localStorage.removeItem(this.refreshTokenName);
  }
}
